const type = {
  free: 1,
  paid: 2,
};

const BluecodersId = '616da3f35bc71862fc6e4e26';

export default { type, BluecodersId };
